import React, { Component } from 'react';

export default class QuantitySelector extends Component {

  constructor(props) {
    super(props);

    this.state = {disableDec: true, disableInc: false}
    this.increment = this.increment.bind(this);
    this.decrement = this.decrement.bind(this);
    this.onTextChange = this.onTextChange.bind(this);
  }



  onQuantityChange(value) {
      this.props.onChange(value);
  }

  increment() {
    const plusState = this.props.value + 1;
    if (this.state.value === (this.props.max - 1)) {
        this.setState({disableInc: true});
    }
    if (this.state.value === this.props.min) {
        this.setState({disableDec: false});
    }
    this.onQuantityChange(plusState);
  }

  decrement() {
    const minusState = this.state.value - 1;
    if (this.state.value > this.props.min) {
        this.onQuantityChange(minusState);
    }
    if (this.state.value === this.props.min + 1) {
        this.setState({disableDec: true});
        this.onQuantityChange(minusState);
    } else {
      this.setState({value: this.props.min});
      this.onQuantityChange(minusState);
    }
  }

  onTextChange = (e) => {
    if (!e.target.value) {
        this.setState({value: 1});
        this.onQuantityChange(1);
    }
    if (e.target.value.length === 0) {
        this.setState({value: 1});
        this.onQuantityChange(1);
    }
    if (e.target.value < 1 || isNaN(e.target.value)) { 
        this.onQuantityChange(1);
        return;
    }
    else {
        this.onQuantityChange(parseInt(e.target.value));
    }
  }

  render() {
    var { disableDec } = this.state;

    return (
      <div className="quantity-picker">
        <button className={`${disableDec ? 'mod-disable ' : ''}quantity-modifier modifier-left btn btn-primary`} style={{height: '44px'}} onClick={this.decrement}>&ndash;</button>
        <input className="quantity-display" style={{border: '3px solid #ccc', borderRadius: '4px', height: '40px',
            width: '225px', marginLeft: '2px', marginRight: '2px'}} type="text" value={this.props.value} onChange={this.onTextChange} />
        <button className={`quantity-modifier modifier-right btn btn-primary`} style={{height: '44px'}} onClick={this.increment}>&#xff0b;</button>
      </div>
    );
  }
}